import { render } from "./UserRegisterForm.vue?vue&type=template&id=c3a7028c"
import script from "./UserRegisterForm.vue?vue&type=script&lang=js"
export * from "./UserRegisterForm.vue?vue&type=script&lang=js"
script.render = render

export default script